import { defineKey as T } from '@ha/intl';
import { ListingContractType } from '@ha/api/v2/types/Listing';

export const ContractTypeOptions = {
  unknown: {
    title: T('listingDetails.Contracttype_unkown'),
    tooltip: '',
  },
  [ListingContractType.DAILY]: {
    title: T('listingDetails.Contracttype_daily'),
    tooltip: T('listingDetails.Contracttype_daily_tooltip'),
  },
  [ListingContractType.MONTHLY]: {
    title: T('listingDetails.Contracttype_monthly'),
    tooltip: T('listingDetails.Contracttype_monthly_tooltip'),
  },
  [ListingContractType.FORTNIGHTLY]: {
    title: T('listingDetails.Contracttype_fortnighly'),
    tooltip: T('listingDetails.Contracttype_fortnighly_tooltip'),
  },
};

export const ContractTypeOptionsAdvertiser = {
  unknown: {
    title: T('listingDetails.Contracttype_unkown'),
    tooltip: '',
  },
  [ListingContractType.DAILY]: {
    title: T('listingDetails.Contracttype_daily'),
    tooltip: T('rental_contract.advertiser.daily.tooltip'),
  },
  [ListingContractType.MONTHLY]: {
    title: T('listingDetails.Contracttype_monthly'),
    tooltip: T('rental_contract.advertiser.monthly.tooltip'),
  },
  [ListingContractType.FORTNIGHTLY]: {
    title: T('listingDetails.Contracttype_fortnighly'),
    tooltip: T('rental_contract.advertiser.fortnightly.tooltip'),
  },
};
